import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import { useHistory } from "react-router-dom";
import Footer from '../elements/Footer.js';
import '../CSS/Login.css'
export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = new URLSearchParams(location.search).get('token');
    const rememberMe = new URLSearchParams(location.search).get('rememberMe');
    // console.log("xxxxx")
    // console.log(rememberMe)
    if (token) {
      if (rememberMe === "true") {
        // localStorage.setItem('authToken', token);
        navigate('/');
      } else {
        // sessionStorage.setItem('authToken', token);
        navigate('/');
      }
    } else {
      window.location.href = `https://auth.jiricech2059.com/login?from=${window.location.origin}`;
    }
  }, [navigate, location]);

  return <div>Redirecting...</div>;
}

